import React from 'react'

import clsx from 'clsx'

import Display from 'components/Display'
import { priceFormatter } from 'helpers/formatters'
import { hasPerUser } from 'helpers/pricing'

import Currency from '../Currency'

import styles from './Amount.module.scss'

/** @type {import("./types").default} */
const Amount = ({ className, pricing = {}, variant = 'large' }) => {
  const price = priceFormatter(pricing.amount)

  return (
    <div className={clsx('Amount', styles.root, styles[variant], className)} data-testid="priceDetails">
      {price ? (
        <>
          <Currency pricing={pricing} />
          <Display data-testid="price" display={price} subscript={hasPerUser(pricing) && '/user'} variant={variant} />
        </>
      ) : (
        <Display display="Free" variant={variant} />
      )}
    </div>
  )
}

export default Amount
